const STORAGE_DATA_ID = "GM_FORM_DATA";

const SCROLL_POSITION_ID = "SCROLL_POSITION";

export function setFormData(type, data) {
    const cloned = { ...data };
    cloned.loadMoreClicked = false;
    const key = STORAGE_DATA_ID + "_" + type;
    sessionStorage.setItem(key, JSON.stringify(cloned));
}

export function setStoreRegions (regions) {
    sessionStorage.setItem("GM_STORE_REGIONS", JSON.stringify(regions));
}

export function getStoreRegions () {
    const regions = sessionStorage.getItem("GM_STORE_REGIONS");
    if (regions) {
        return JSON.parse(regions);
    } else {
        return [];
    }
}

export function setStoreCities (cities) {
    sessionStorage.setItem("GM_STORE_CITIES", JSON.stringify(cities));
}

export function getStoreCities () {
    const cities = sessionStorage.getItem("GM_STORE_CITIES");
    if (cities) {
        return JSON.parse(cities);
    } else {
        return [];
    }
}

export function setStoreLoadMore (loadMore) {
    sessionStorage.setItem("GM_STORE_LOAD_MORE", JSON.stringify(loadMore));
}

export function getStoreLoadMore () {
    const loadMore = sessionStorage.getItem("GM_STORE_LOAD_MORE");
    if (loadMore) {
        return JSON.parse(loadMore);
    } else {
        return [];
    }
}

export function setStorePanels (panels) {
    sessionStorage.setItem("GM_STORE_PANELS", JSON.stringify(panels));
}

export function getStorePanels () {
    const panels = sessionStorage.getItem("GM_STORE_PANELS");
    if (panels) {
        return JSON.parse(panels);
    } else {
        return [];
    }
}

export function getFormData(type) {
    try {
        const key = STORAGE_DATA_ID + "_" + type;
        const data = sessionStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        } else {
            return getInitialData(); 
        }
    } catch (e) {
        return undefined;
    }
}

export function getInitialData() {
    return {
        offset: 0,
        loadMoreClicked: false,
        text: "",
        regionIDs: [],
        cityIDs: [],
        adFormatIDs: [],
        adShapeIDs: [],
        gender: "",
        age: "",
        location: "",
        splitView: false,
    };
}

export function clearFormData(type) {
    sessionStorage.removeItem(STORAGE_DATA_ID + "_" + type);
}

export function setScrollPosition(type, pos) {
    const key = SCROLL_POSITION_ID + "_" + type;
    sessionStorage.setItem(key, pos);
}

export function getScrollPosition(type) {
    try {
        const key = SCROLL_POSITION_ID + "_" + type;
        return sessionStorage.getItem(key);
    } catch (e) {
        return undefined;
    }
}

export function clearScrollPosition(type) {
    sessionStorage.removeItem(SCROLL_POSITION_ID + "_" + type);
}

export function filterGTMDataPush(
    type,
    variables = {},
    context = {},
    value = [],
    options,
    isMulti = null
) {
    const isRegionSelect = type === "regionSelect";
    let displayValue = "";
    if (isMulti) {
        const selectedOptions = options
            .filter((option) => value.some((val) => option.id === val))
            .map((option) => option.title);

        displayValue = selectedOptions.join(" | ");
    } else if (isRegionSelect) {
        // Convert selected regions into an array of strings formatted region: city,city
        const selectedRegions = context.props.settings.regions
            .filter((region) =>
                variables.regionIDs.some((id) => id === region.id)
            )
            .map(
                (region) =>
                    `${region.title}: ${region.cities
                        .filter((city) =>
                            variables.cityIDs.some((id) => id === city.id)
                        )
                        .map((city) => city.title)}`
            );
        displayValue = selectedRegions.join(" | ");
    } else {
        displayValue = value;
    }

    const data = {
        event: "Go Planner",
        filterType: type.replace("ID", ""),
        filterValue: displayValue,
        searchFieldText: variables.text,
    };
    window.dataLayer.push(data)
}
